module.exports = __webpack_public_path__ + "static/img/jin_hua.32df64ef.png";